if (!customElements.get('gift-box-modal')) {
  customElements.define(
    'gift-box-modal',
    class GiftBoxModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('.giftbox-modal');
        this.addToCartButton = this.querySelector('[data-giftbox-add-to-cart]');
        this.errorMessage = this.querySelector('[data-giftbox-error]');
        this.selectedVariantIds = new Set();
        this.boxVariantId = null;
        this.boxTitle = '';

        this.querySelectorAll('[data-giftbox-close]').forEach((el) => el.addEventListener('click', this.close.bind(this)));
        this.querySelectorAll('[data-perfume-toggle]').forEach((el) => el.addEventListener('click', this.onToggle.bind(this)));
        this.addToCartButton.addEventListener('click', this.onAddToCart.bind(this));
        this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
      }

      openWithBox(variantId, title) {
        this.boxVariantId = variantId;
        this.boxTitle = title || '';
        this.selectedVariantIds.clear();
        this.querySelectorAll('[data-perfume-toggle]').forEach((button) => {
          button.classList.remove('is-selected');
          // Set the label span's text only, not the button's — textContent on
          // the button itself would wipe out the checkmark icon alongside it.
          button.querySelector('[data-perfume-toggle-label]').textContent = 'Select';
          button.setAttribute('aria-pressed', 'false');
        });
        this.errorMessage.hidden = true;
        this.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
      }

      onToggle(event) {
        const button = event.currentTarget;
        const selected = button.classList.toggle('is-selected');
        button.querySelector('[data-perfume-toggle-label]').textContent = selected ? 'Selected' : 'Select';
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');

        if (selected) {
          this.selectedVariantIds.add(button.dataset.variantId);
          this.errorMessage.hidden = true;
        } else {
          this.selectedVariantIds.delete(button.dataset.variantId);
        }
      }

      buildGiftGroupId() {
        const prefix = (this.boxTitle.match(/[a-zA-Z]/g) || []).join('').slice(0, 4).toUpperCase() || 'GIFT';
        const suffix = Math.random().toString(36).slice(2, 6).toUpperCase();
        return `${prefix}-${suffix}`;
      }

      onAddToCart() {
        if (!this.boxVariantId || this.addToCartButton.getAttribute('aria-disabled') === 'true') return;

        if (this.selectedVariantIds.size === 0) {
          this.errorMessage.hidden = false;
          return;
        }

        const giftGroupId = this.buildGiftGroupId();
        const properties = { 'Gift Group': giftGroupId };
        const items = [{ id: this.boxVariantId, quantity: 1, properties }];
        this.selectedVariantIds.forEach((id) => items.push({ id, quantity: 1, properties }));

        this.addToCartButton.setAttribute('aria-disabled', 'true');
        this.addToCartButton.classList.add('loading');
        this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              throw new Error(response.description || response.message);
            }
            this.close();
            if (cart) {
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents(response);
            }
          })
          .catch((error) => console.error('Gift box add to cart failed:', error))
          .finally(() => {
            this.addToCartButton.removeAttribute('aria-disabled');
            this.addToCartButton.classList.remove('loading');
            this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-giftbox-select-box]');
  if (!trigger) return;

  event.preventDefault();

  const section = trigger.closest('.shopify-section');
  const modal = (section && section.querySelector('gift-box-modal')) || document.querySelector('gift-box-modal');
  if (modal) modal.openWithBox(trigger.dataset.boxVariantId, trigger.dataset.boxTitle);
});
